<style>
/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

#berusahaBendahara_info,
#berusahaBendahara_paginate,
#berusahaBendahara_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nama_pemohon">Nama Pemohon</option>
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="lokasi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl Submit</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="berusahaBendahara" class="table" style="width: 100%">
          <thead>
            <tr>
              <th class="all">No</th>
              <th class="all">Nama Pemohon</th>
              <th style="display:none">NIB</th>
              <th style="display:none">Nomor Proyek</th>
              <th style="display:none">KBLI</th>
              <th style="display:none">Jenis Proyek</th>
              <th style="display:none">Risiko</th>
              <th style="display:none">Skala Usaha</th>
              <th style="display:none">PIC Dokumen</th>
              <th class="all">Nomor Pemohon</th>
              <th class="all">Jenis Kegiatan</th>
              <th class="all">Nama Perairan</th>
              <th class="all">Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th class="all">Tgl. Permohonan</th>
              <th>Tgl. Proses</th>
              <th>Tanggal Berlaku Tagihan</th>
              <th>Status Tagihan</th>
              <th>PIC Pentek</th>
              <th style="text-align: center">Unduh File</th>
              <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
              <th class="all">Aksi</th>
            </tr>
            <!-- <tr>
                        <th>Bukti Pembayaran</th>
                        <th>Surat Tugas</th>
                        <th>Undangan</th>
                        <th>BA</th>
                        <th>Memo</th>
                        <th>Persetujuan</th>
                    </tr> -->
          </thead>
          <tbody>
            <tr v-for="(row, index) in dataPermohonan" :key="row.id">
              <td class="sticky-col second-col">
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  index + pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">{{ index + pagination.firstInPage }}</div>
                </span>
              </td>
              <td class="sticky-col second-col">
                <div v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red;width: 250px;"
                  class="text-wrap">{{
                    row.nama_pemohon
                  }}</div>
                <div v-else style="width: 250px;" class="text-wrap">
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.nama_pemohon }}
                  </div>
                </div>
                <div v-if="row.tipe_permohonan == 'Multi KBLI' & row.tipe_multi_kbli == 'Mengikuti'"
                  class="text-secondary" style="font-size: 12px;">
                  Pendukung
                </div>
                <div v-else-if="row.tipe_permohonan == 'Multi KBLI' & row.tipe_multi_kbli == 'Proses'"
                  class="text-primary" style="font-size: 12px;">
                  Proses
                </div>
              </td>
              <td style="display: none">{{ row.nib_pemohon }}</td>
              <td style="display: none">{{ row.nomor_proyek }}</td>
              <td style="display: none">{{ row.kbli }}</td>
              <td style="display: none">{{ row.jenis_proyek }}</td>
              <td style="display: none">{{ row.risiko }}</td>
              <td style="display: none">{{ row.skala_usaha }}</td>
              <td style="display: none">{{ row.nama_pic_verdok }}</td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.nomor_permohonan
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.nomor_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{
                    row.jenis_kegiatan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' }, { width: '300px' }
                  ]">
                    {{ row.jenis_kegiatan }}
                  </div>
                </div>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{
                    row.nama_perairan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' }, { width: '300px' }
                  ]">
                    {{ row.nama_perairan }}
                  </div>
                </div>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.lokasi
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.lokasi }}
                  </div>
                </span>
              </td>
              <!-- <td>
              <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                row.status_verdok
              }}</span>
              <span v-else>
                <div :style="[
                  row.prioritas ? { color: 'green' } : { color: 'black' },
                ]">
                  {{ row.status_verdok }}
                </div>
              </span>
            </td> -->
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.status_permohonan
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.status_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.keterangan_status
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.keterangan_status }}
                  </div>
                </span>
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null &&
                  row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null && row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span v-if="row.status_tagihan_iii != null">
                    {{ row.status_tagihan_iii }}
                  </span>
                  <span v-else-if="
                    row.status_tagihan_ii != null &&
                    row.status_tagihan_i != null
                  ">
                    {{ row.status_tagihan_ii }}
                  </span>
                  <span v-else>
                    {{ row.status_tagihan_i }}
                  </span>
                </span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <span v-if="row.status_tagihan_iii != null">
                      {{ row.status_tagihan_iii }}
                    </span>
                    <span v-else-if="
                      row.status_tagihan_ii != null &&
                      row.status_tagihan_i != null
                    ">
                      {{ row.status_tagihan_ii }}
                    </span>
                    <span v-else>
                      {{ row.status_tagihan_i }}
                    </span>
                  </div>
                </span>
              </td>
              <td>
                {{ row.pic_name }}
              </td>
              <td>
                <div style="width: 250px">
                  <div class="row">
                    <div class="col-md-8">
                      <select v-model="row.selectedFile" style="width: 150px; margin-right: 10px" class="form-select"
                        aria-label="Default select example">
                        <option disabled value="">- Pilih File -</option>
                        <option value="verdok" :disabled="row.file_ba_verdok == null
                          ">
                          Verdok
                        </option>

                        <!-- Option File Tagihan -->
                        <option value="tagihan_1" :disabled="row.file_tagihan_i == null">
                          <i class="la la-edit"></i> Tagihan 1
                        </option>

                        <option value="tagihan_2" :disabled="row.file_tagihan_ii == null">
                          <i class="la la-edit"></i> Tagihan 2
                        </option>

                        <option value="tagihan_3" :disabled="row.file_tagihan_iii == null">
                          <i class="la la-edit"></i> Tagihan 3
                        </option>

                        <option value="pembayaran" :disabled="row.bukti_pembayaran == null">
                          Bukti Pembayaran
                        </option>
                        <option value="surattugas" :disabled="row.filename_final_surat_tugas == null &&
                          row.filename_konsep_surat_tugas == null
                          ">
                          Surat Tugas
                        </option>
                        <option value="undangan" :disabled="row.filename_final_undangan == null &&
                          row.filename_konsep_undangan == null
                          ">
                          Undangan
                        </option>
                        <option value="ba" :disabled="row.file_ba_vertek == null">
                          Berita Acara
                        </option>
                        <option value="shp" :disabled="row.file_shp == null">
                          File SHP
                        </option>

                        <option value="resume" :disabled="row.file_resume_permohonan == null &&
                          row.file_resume_permohonan == null
                          ">
                          Resume Permohonan
                        </option>
                        <option value="persetujuan" :disabled="row.file_persetujuan == null">
                          Final Surat Persetujuan
                        </option>
                        <!-- <option value="epersetujuan" :disabled="row.file_izin_ttd == null">
                      Final Surat Persetujuan Elektronik
                    </option> -->

                        <option value="oss" :disabled="row.file_final_oss == null">
                          Final Persetujuan OSS
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mt-2">
                      <span v-if="
                        row.file_ba_verdok != null &&
                        row.selectedFile == 'verdok'
                      ">
                        <a :href="row.file_ba_verdok" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file verifikasi dokumen" /></a>
                      </span>

                      <!-- Download File Tagihan -->
                      <span v-if="
                        row.file_tagihan_iii != null &&
                        row.selectedFile == 'tagihan_3'
                      ">
                        <a :href="row.file_tagihan_iii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 3" /></a>
                      </span>
                      <span v-if="
                        row.file_tagihan_ii != null &&
                        row.selectedFile == 'tagihan_2'
                      ">
                        <a :href="row.file_tagihan_ii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 2" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_tagihan_i != null &&
                        row.selectedFile == 'tagihan_1'
                      ">
                        <a :href="row.file_tagihan_i" target="_blank"><i class="fa fa-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file tagihan 1" /></a>
                      </span>

                      <!-- <br> -->
                      <span v-if="
                        row.bukti_pembayaran != null &&
                        row.selectedFile == 'pembayaran'
                      ">
                        <a :href="row.bukti_pembayaran" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file bukti pembayaran" />
                        </a>
                      </span>

                      <span v-if="
                        row.filename_final_surat_tugas != null &&
                        row.selectedFile == 'surattugas'
                      ">
                        <a :href="row.filename_final_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>
                      <span v-else-if="
                        row.filename_konsep_surat_tugas != null &&
                        row.selectedFile == 'surattugas'
                      ">
                        <a :href="row.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file surat tugas" /></a>
                      </span>

                      <span v-if="
                        row.filename_final_undangan != null &&
                        row.selectedFile == 'undangan'
                      ">
                        <a :href="row.filename_final_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>
                      <span v-else-if="
                        row.filename_konsep_undangan != null &&
                        row.selectedFile == 'undangan'
                      ">
                        <a :href="row.filename_konsep_undangan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file undangan" /></a>
                      </span>

                      <span v-if="
                        row.file_ba_vertek != null && row.selectedFile == 'ba'
                      ">
                        <a :href="row.file_ba_vertek" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file berita acara" /></a>
                      </span>

                      <span v-if="
                        row.file_final_memorandum != null &&
                        row.selectedFile == 'memo'
                      ">
                        <a :href="row.file_final_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>
                      <span v-else-if="
                        row.file_konsep_memorandum != null &&
                        row.selectedFile == 'memo'
                      ">
                        <a :href="row.file_konsep_memorandum" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file memo" /></a>
                      </span>

                      <span v-if="
                        row.file_persetujuan != null &&
                        row.selectedFile == 'persetujuan'
                      ">
                        <a :href="row.file_persetujuan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_izin_ttd != null &&
                        row.selectedFile == 'epersetujuan'
                      ">
                        <a :href="row.file_izin_ttd" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan elektronik" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_final_oss != null &&
                        row.selectedFile == 'oss'
                      ">
                        <a :href="row.file_final_oss" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file persetujuan OSS" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_resume_permohonan != null &&
                        row.selectedFile == 'resume'
                      ">
                        <a :href="row.file_resume_permohonan" target="_blank"><i class="fa fa-cloud-download"
                            aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                            title="Unduh file resume permohonan" />
                        </a>
                      </span>

                      <span v-if="
                        row.file_shp != null &&
                        row.selectedFile == 'shp'
                      ">
                        <a :href="row.file_shp" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"
                            style="font-size: 20px" data-toggle="tooltip" data-placement="top" title="Unduh file SHP" />
                        </a>
                      </span>



                    </div>
                  </div>

                  <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="row.selectedFile"
                                    :options="optionsFile"></b-form-select> -->
                </div>
              </td>


              <td>
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail" @click="
                  $router.push('/app/penambahan-kbli/detail-perizinan/' + row.id)
                  " class="text-white m-1"><i class="fa fa-eye" /> Detail</b-button>

                <template v-if="row.nomor_ba_vertek != null && row.tipe_multi_kbli != 'Mengikuti'">
                  <b-button v-if="row.bukti_pembayaran == null" variant="primary" size="sm" style="margin-right: 5px"
                    @click="verifPembayaran(row.id)"><i class="fa fa-file-text-o" /> Buat Tagihan</b-button>
                  <b-button v-else hidden variant="primary" size="sm" style="margin-right: 5px"
                    @click="verifPembayaran(row.id)"><i class="fa fa-file-text-o" /> Buat
                    Tagihan</b-button>

                  <b-button v-if="canCheckStatusBayar(row)" size="sm" variant="secondary"
                    class="d-inline-flex align-items-center px-3 py-2 shadow-sm" @click="checkStatusBayar(row)">
                    <i class="fa fa-search mr-2"></i>Cek Status Pembayaran
                  </b-button>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import * as xlsx from "xlsx";
export default {
  data() {
    return {
      fields: [
        "no",
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_verdok", label: "Status", sortable: true },
        { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
        { key: "tanggal_berlaku", label: "Tanggal Berlaku Tagihan" },
        { key: "status_tagihan", label: "Status Tagihan" },
        "Aksi",
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: "", count: "", limit: "" },
        columnsClasses: { id: "width-100" },
        skin: "table table-striped",
        sortIcon: {
          base: "fa text-muted",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
      },

      // currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      dataPermohonan: [],
      selectedFile: null,

      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: null,
        pageNumber: [],
        limit: 0,
        total: 0,
        firstInPage: 0,
      },
      search: {
        field: "nama_pemohon",
        value: "",
      },
      sort: {
        field: "createdAt",
        direction: "DESC",
      },
      debounceTerm: null,
      show: false
    };
  },
  props: {
    itemsWithNumber: {
      type: Array,
      default: () => {
        return [];
      },
    },
    rows: Number,

    totalRows: Number,
    currentPage: Number,
    user: {
      // type: Array,
      default: () => {
        return [];
      },
    },
    baseapi: String,
  },
  mounted() {
    this.getdata();
  },
  methods: {
    onFiltered(data) {
      this.$emit("onFiltered", data);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD MMMM YYYY");
      }
    },
    pilihModal() {
      this.$emit("pilihModal");
    },
    getDetailPerDokumen(data) {
      this.$emit("getDetailPerDokumen", data);
    },
    deleteDokumen(data) {
      this.$emit("deleteDokumen", data);
    },
    verifPembayaran(data) {
      this.$emit("verifPembayaran", data);
    },

    async getdata() {
      $("#berusahaBendahara").DataTable().destroy();
      await this.loaddata();
    },

    loaddata() {
      this.show = true
      // const api = `api/penambahan_kbli/dataTable?page=${this.pagination.currentPage}${this.search.value ? `&filter=${this.search.field},like,${this.search.value}` : ''}`
      const api = `api/penambahan_kbli/dataTable` +
        `?page=${this.pagination.currentPage}` +
        `${this.search.value !== '' ? `&filter=${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value};perlu_pnbp,=,true` : '&filter=perlu_pnbp,=,true'}` +
        `&sort=${this.sort.field},${this.sort.direction}`
      return axios
        .get(this.baseapi + api, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          const data = response.data
          this.pagination.limit = data.limit
          this.pagination.total = data.total
          this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
          this.pagination.lastPage = Math.ceil(data.total / data.limit)
          this.setPagination()
          this.dataPermohonan = response.data.data;
          for (let index = 0; index < this.dataPermohonan.length; index++) {
            Vue.set(this.dataPermohonan[index], "selectedFile", null);
          }
          this.initDatatable();
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          this.show = false
        });
    },


    //Emit Check status pembayaran
    checkStatusBayar(data) {
      this.$emit("checkStatusBayar", data, "bendahara");
    },

    getBillingTerakhir(row) {
      if (row.kode_billing_tagihan_iii) {
        return {
          kode: row.kode_billing_tagihan_iii,
          status: row.status_tagihan_iii
        }
      }

      if (row.kode_billing_tagihan_ii) {
        return {
          kode: row.kode_billing_tagihan_ii,
          status: row.status_tagihan_ii
        }
      }

      if (row.kode_billing_tagihan_i) {
        return {
          kode: row.kode_billing_tagihan_i,
          status: row.status_tagihan_i
        }
      }

      return null
    },

    canCheckStatusBayar(row) {
      const billing = this.getBillingTerakhir(row)

      return billing && billing.status !== 'Sudah Dibayar'
    },

    setPagination() {
      this.$router.replace({
        path: this.$route.path,
        query: { page: this.pagination.currentPage },
      }).catch((err) => { })
      this.pagination.pageNumber = []
      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('2')
          this.pagination.pageNumber.push('3')
          this.pagination.pageNumber.push('4')
          this.pagination.pageNumber.push('5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 4}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 3}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 2}`)
        } else {
          this.pagination.pageNumber.push('1')
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.currentPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
          this.pagination.pageNumber.push(`${this.pagination.currentPage + 1}`)
        }
        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`)
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...')
          this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next') {
        if (this.pagination.currentPage < this.pagination.lastPage) {
          this.pagination.currentPage++
        }
      }
      if (config.option === 'prev') {
        if (this.pagination.currentPage > 1) {
          this.pagination.currentPage--
        }
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        if (config.page === '...') return
        this.pagination.currentPage = parseInt(config.page)
      }
      this.setPagination()
      await this.getdata()
      $('html,body').scrollTop(1000)
    },

    initDatatable() {
      $.fn.dataTable.moment("DD MMMM YYYY");
      setTimeout(() => {
        var t = $("#berusahaBendahara").DataTable({
          pagingType: "full_numbers",
          language: {
            info: "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
            paginate: {
              first: "Awal",
              last: "Akhir",
              next: "Selanjutnya",
              previous: "Sebelumnya",
            },
          },
          // order: [[0, 'desc']],
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: {
            left: 2,
            right: 1,
          },
          scrollX: true,
          // stateSave: true,
          dom: "Bfrtip",
          // fnRowCallback: function (
          //   nRow,
          //   aData,
          //   iDisplayIndex,
          //   iDisplayIndexFull
          // ) {
          //   //debugger;
          //   var index = iDisplayIndexFull + 1;
          //   $("td:first", nRow).html(index);
          //   return nRow;
          // },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == "export" ? meta.row : data);
                return type == "export" ? meta.row + 1 : data;
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   extend: "excelHtml5",
            //   title: "DATA PEMOHON",
            //   text: '<i class="fa fa-file-text-o"></i> Excel',
            //   className: "btn text-white btn-success",
            //   exportOptions: {
            //     columns: [0,15,1, 2,9,3, 4, 5, 6, 7,11,12, 8],
            //     orthogonal: "export",
            //     // format: {
            //     //     header: function ( data, columnIdx ) {
            //     //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
            //     //         return 'Aktivitas ' + data;
            //     //         }
            //     //         else if(columnIdx==10 || columnIdx==11){
            //     //           return 'Verifikasi Dokumentatif ' + data;
            //     //         }
            //     //         else if(columnIdx==12 || columnIdx==13){
            //     //           return 'Verifikasi Lapangan ' + data;
            //     //         }
            //     //         else if(columnIdx==14 || columnIdx==15){
            //     //           return 'File BA ' + data;
            //     //         }
            //     //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
            //     //           return 'Predikat ' + data;
            //     //         }
            //     //         else{
            //     //           return data;
            //     //         }
            //     //     },
            //     //     body: function(data, row, column, node) {
            //     //         data = $('<p>' + data + '</p>').text();
            //     //         return data.replace(',', '.');
            //     //     },
            //     // }
            //   },
            //   filename: function () {
            //     var today = new Date();
            //     // var n = d.getTime();
            //     var date =
            //       today.getFullYear() +
            //       "-" +
            //       (today.getMonth() + 1) +
            //       "-" +
            //       today.getDate();

            //     return "Data Pemohon " + date;
            //   },
            // },
          ],
        });
        // t.on("order.dt search.dt", function () {
        //   t.column(0, { search: "applied", order: "applied" })
        //     .nodes()
        //     .each(function (cell, i) {
        //       cell.innerHTML = i + 1;
        //     });
        // }).draw();
      }, 300);
    },

    exportData() {
      this.$loading(true);
      const api = `api/penambahan_kbli` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `${this.search.value !== '' ? `&filter=${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`

      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Prioritas', 'Nama Pemohon', 'Nomor Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Pentek', 'Tgl. Permohonan', 'Tgl. Proses', 'Tgl. Berlaku Tagihan', 'Status Tagihan', 'PIC Pentek'],
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } }]

        res.data.data.forEach((d, i) => {
          worksheetData.push([
            i + 1,
            d.prioritas ? 'Prioritas' : '',
            d.nama_pemohon,
            d.nomor_permohonan,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.lokasi,
            d.status_verdok,
            d.status_vertek,
            d.tanggal_pada_permohonan,
            d.tanggal_proses,
            d.tanggal_berlaku_hingga_tagihan_iii
              ? d.tanggal_berlaku_hingga_tagihan_iii
              : d.tanggal_berlaku_hingga_tagihan_ii
                ? d.tanggal_berlaku_hingga_tagihan_ii
                : d.tanggal_berlaku_hingga_tagihan_i
                  ? d.tanggal_berlaku_hingga_tagihan_i
                  : '',
            d.status_tagihan_iii
              ? d.status_tagihan_iii
              : d.status_tagihan_ii
                ? d.status_tagihan_ii
                : d.status_tagihan_i
                  ? d.status_tagihan_i
                  : '',
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false);
      })
    }
  },
  watch: {
    search: {
      handler: function (val) {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.getdata();
        }, 1000)
      },
      deep: true,
    },
    sort: {
      handler: function (val) {
        this.pagination.currentPage = 1
        this.getdata();
      },
      deep: true,
    },
  },
};
</script>